// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}
.truongHopSuDungDat_item {
  display: flex;
  margin-left: 6px;
}
.truongHopSuDungDat_title {
  font-size: 16px;
  font-weight: 400;
}
.truongHopSuDungDat_item_name {
  margin-left: 6px;
  font-size: 14px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  color: #000000b3;
  cursor: pointer;
}
.add-infor {
  cursor: pointer;
}
.title_list_item {
  margin: 0;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  letter-spacing: 0.01071em;
  color: #000000b3;
  margin-bottom: 5px !important;
  font-size: 14px;
}
.message_error {
  color: #f44335 !important;
  margin-top: 5px !important;
  font-size: 13px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  font-weight: 400;
  margin-bottom: 0;
}
.scrollMarginTop {
  scroll-margin: 70px;
}

.tableList-button-dangHoatDong {
  background-color: #52cd52;
  padding: 1px 7px 1px 7px;
  border-radius: 10px;
  color: white;
}

.tableList-button-ngungHoatDong {
  background-color: #919191;
  padding: 1px 7px 1px 7px;
  border-radius: 10px;
  color: white;
}

/* fix placeholder auto uppercase */
::-webkit-input-placeholder {
  /* WebKit browsers */
  text-transform: none;
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  text-transform: none;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  text-transform: none;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  text-transform: none;
}

.ag-header-cell-text {
  color: #344767 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,uDAAuD;EACvD,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,uDAAuD;EACvD,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,uDAAuD;EACvD,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\r\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\r\n    monospace;\r\n}\r\n.truongHopSuDungDat_item {\r\n  display: flex;\r\n  margin-left: 6px;\r\n}\r\n.truongHopSuDungDat_title {\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n}\r\n.truongHopSuDungDat_item_name {\r\n  margin-left: 6px;\r\n  font-size: 14px;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-weight: 400;\r\n  color: #000000b3;\r\n  cursor: pointer;\r\n}\r\n.add-infor {\r\n  cursor: pointer;\r\n}\r\n.title_list_item {\r\n  margin: 0;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-weight: 400;\r\n  font-size: 0.875rem;\r\n  line-height: 1.43;\r\n  letter-spacing: 0.01071em;\r\n  color: #000000b3;\r\n  margin-bottom: 5px !important;\r\n  font-size: 14px;\r\n}\r\n.message_error {\r\n  color: #f44335 !important;\r\n  margin-top: 5px !important;\r\n  font-size: 13px;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  line-height: 1.66;\r\n  letter-spacing: 0.03333em;\r\n  text-align: left;\r\n  font-weight: 400;\r\n  margin-bottom: 0;\r\n}\r\n.scrollMarginTop {\r\n  scroll-margin: 70px;\r\n}\r\n\r\n.tableList-button-dangHoatDong {\r\n  background-color: #52cd52;\r\n  padding: 1px 7px 1px 7px;\r\n  border-radius: 10px;\r\n  color: white;\r\n}\r\n\r\n.tableList-button-ngungHoatDong {\r\n  background-color: #919191;\r\n  padding: 1px 7px 1px 7px;\r\n  border-radius: 10px;\r\n  color: white;\r\n}\r\n\r\n/* fix placeholder auto uppercase */\r\n::-webkit-input-placeholder {\r\n  /* WebKit browsers */\r\n  text-transform: none;\r\n}\r\n\r\n:-moz-placeholder {\r\n  /* Mozilla Firefox 4 to 18 */\r\n  text-transform: none;\r\n}\r\n\r\n::-moz-placeholder {\r\n  /* Mozilla Firefox 19+ */\r\n  text-transform: none;\r\n}\r\n\r\n:-ms-input-placeholder {\r\n  /* Internet Explorer 10+ */\r\n  text-transform: none;\r\n}\r\n\r\n.ag-header-cell-text {\r\n  color: #344767 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
